module.exports = __webpack_public_path__ + "img/cgd4.a278b32a.jpg";